import { drawersConfiguration } from '@/features/drawer/constants/drawersConfiguration';
import { Drawers } from '@/features/drawer/enums/Drawers';

export class DrawerService {
  public static prepareSearchParams(
    drawer: Drawers,
    params: Record<string, number | string | boolean | null | undefined>,
    saveCurrentParams: boolean = true,
  ) {
    const searchParams = saveCurrentParams ? new URLSearchParams(location.search) : new URLSearchParams();
    const drawerConfiguration = drawersConfiguration?.[drawer];
    const hasExtraParams = Boolean(drawerConfiguration?.router?.drawerExtraParams);
    const uniqPrefix = drawerConfiguration?.router?.drawerParam;
    const allowedParams = hasExtraParams ? drawerConfiguration?.router?.drawerExtraParams || [] : [];

    searchParams.set(drawer, 'true');

    if (Object.keys(params).length) {
      Object.keys(params).forEach((param) => {
        if (!hasExtraParams || (hasExtraParams && allowedParams.includes(param))) {
          if (params[param] !== undefined || params[param] !== null) {
            searchParams.set(uniqPrefix ? `${uniqPrefix}-${param}` : param, String(params[param]));
          }
        }
      });
    }

    return searchParams.toString();
  }
}
